import { render, staticRenderFns } from "./permissionrulelist.vue?vue&type=template&id=acca7f5e&scoped=true"
import script from "./permissionrulelist.vue?vue&type=script&lang=js"
export * from "./permissionrulelist.vue?vue&type=script&lang=js"
import style0 from "./permissionrulelist.vue?vue&type=style&index=0&id=acca7f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acca7f5e",
  null
  
)

export default component.exports